// Mirrors SelfServiceTrial::BALANCE_SOFT_LIMIT on the backend.
export const TRIAL_BALANCE_SOFT_LIMIT_USD = 1
export const TRIAL_BALANCE_BLOCK_LIMIT_USD = 0

const SESSION_LOW_DISMISS_KEY = "trial_balance_low_dismissed"

export const isTrialBalanceLowDismissedThisSession = (): boolean => {
  try {
    return window.sessionStorage.getItem(SESSION_LOW_DISMISS_KEY) === "1"
  } catch {
    return false
  }
}

export const markTrialBalanceLowDismissed = (): void => {
  try {
    window.sessionStorage.setItem(SESSION_LOW_DISMISS_KEY, "1")
  } catch {
    /* sessionStorage unavailable — non-fatal */
  }
}
